module.exports = __webpack_public_path__ + "12116c9270d6a33411ec8fd07b2ce4ec.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-8.png
// module id = 146
// module chunks = 0